import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { venueclosings_returndata } from 'src/types/venueclosings_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-venueclosings',
  templateUrl: './venueclosings.component.html',
  styleUrls: ['./venueclosings.component.css']
})
export class VenueclosingsComponent implements OnInit {
  ListVenueClosings: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  VenueClosing: any;
  DisabledVenueClosing: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  httpResponse: any;

  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;

  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService,private globalService: GlobalService) { 

      
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("VENUECLOSINGS", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;
        
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });


  }

  toggleDisabled(){
    this.loadgrid(!this.isDisabled);
  }

  disableData(VenueClosingID)
  {
    this.http.delete(bmxurl + "VenueClosing/" + this.VenueID + "/" + VenueClosingID).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Disabled', detail:'Venue Closing successfully disabled'});
        this.router.navigateByUrl("/venueclosing");

        this.loadgrid(false);
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Venue Closing'});
    })
  }
  

  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "VenueClosingList/" + this.VenueID + "/" + "/" + showdisabled).subscribe(response => {
      this.ListVenueClosings = (response as venueclosings_returndata);

      if ((response as venueclosings_returndata).messages.length > 0)
        {
          (response as venueclosings_returndata).messages.forEach(error => {
            this.messageService.add({severity:'warn', summary:'Response Message', detail: error});
          });
        }
    }, error => {
    });
  }

  editData(EditData)
  {
    let VenueClosingID = EditData;
    this.router.navigateByUrl("/venueclosingsedit/" + VenueClosingID);
  }

  disableMulti()
  {
    this.selectedItems.forEach(element => {

    this.http.delete(bmxurl + "/VenueClosingList/" + this.VenueID + "/" + element).subscribe(response => {
      this.CreateUpdateResponse = response
      if(this.CreateUpdateResponse.succeeded)
      {
        this.loadgrid(false);
      } 
    }, error => {
    
    })
    });
    
  }

  uncheckAll() {
    this.checkboxes[0].checked = true;
  }
  
  }